import { PHOTO_FACET_TYPE_LIST } from '../constants';

import { type PhotoFacetType } from '../types';

export const isPhotoFacetType = (param?: string): param is PhotoFacetType => {
    const photoFacetTypes: readonly string[] = PHOTO_FACET_TYPE_LIST;
    return photoFacetTypes.includes(param || '');
};
